import { isMapV2Enabled } from '@/lib/featureFlags';
import { MapPageLegacy } from './legacy';
import { MapPageV2 } from './v2';

export function MapPage() {
  return isMapV2Enabled() ? <MapPageV2 /> : <MapPageLegacy />;
}
